<template>
  <v-menu
    v-model="menu"
    :disabled="disabled"
    offset-y
    transition="scale-transition"
    origin="top left"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        :class="{ 'disabled': disabled, 'selected': selected }"
        :color="disabled ? '#333333' : 'tertiary'"
        v-bind="attrs"
        v-on="on"
        :close="true"
        @click:close="selected ? clearFilter() : menu = true"
        :text-color="disabled ? '#A0A5AE' : 'tertiary'"
        :close-icon="selected ? closeIcon : filterIcon"
        :outlined="!(selected || disabled)"
        :ripple="!disabled"
      >
        <span>{{ text }}</span>
      </v-chip>
    </template>
    <v-list class="filter-options">
      <v-list-item>
        <v-list-item-title><strong>{{ filterTitle }}</strong></v-list-item-title>
        <v-list-item-action>
          <v-btn
            icon
            small
            aria-label="Close filter options menu"
            @click="menu = false"
          >
            <v-icon>
              close
            </v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <slot name="selectionsSlot">
        <div v-if="type === 'checkbox'">
          <v-list-item
            v-for="filter in filterOptions"
            :key="filter.value"
          >
            <v-checkbox
              v-model="selectedOptions"
              :label="filter.label"
              :value="filter.value"
              class="checkFilter mt-0"
              @click="$emit('update', selectedOptions)"
            />
          </v-list-item>
        </div>
        <div v-if="type === 'radio'">
          <v-radio-group
            v-model="radioOption"
            class="mt-0"
          >
            <v-list-item
              v-for="filter in filterOptions"
              :key="filter.value"
            >
              <v-radio
                :key="filter.value"
                :label="filter.label"
                :value="filter.value"
                @click="$emit('update', radioOption)"
              />
            </v-list-item>
          </v-radio-group>
        </div>
      </slot>
      <AdsButton
        v-if="!hideClearLink"
        tertiary
        small
        class="text--primary text-decoration-underline clear-filter"
        @click="clearFilter"
        :button-text="clearLinkText"
      />
    </v-list>
  </v-menu>
</template>
<script>

import AdsButton from '../AdsButton'

export default {
  name: 'ChipFilter',
  data() {
      return {
        menu: false,
        selectedOptions: [],
        radioOption: ''
      }
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filterIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    closeIcon: {
      type: String,
      default: 'cancel'
    },
    filterTitle: {
      type: String,
      default: 'Show only'
    },
    filterOptions: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: '',
      validator: function (value) {
        // allow only checkbox/radio
        return ['checkbox', 'radio', ''].indexOf(value) !== -1
      }
    },
    clearLinkText: {
      type: String,
      default: 'Clear filter'
    },
    hideClearLink: { // hides the bottom link to clear the filters
      type: Boolean,
      default: false
    },
    clear: Function, // function for clearing the filter values used in chip close action
    update: Function, // function for updating the filters
    value: { // selected values for the checkbox filter
      type: Array,
      default: () => []
    }
  },
  computed: {
    selected() { // determines if data is filtered
      return (this.value && this.value.length) > 0 || this.radioOption !== ''
    }
  },
  methods: {
    // cleanup filter values
    clearFilter () {
      if (this.disabled) {
        return;
      }
      if (this.type === 'radio') {
        this.radioOption = ''
      } else {
        this.selectedOptions = [];
      }
      this.$emit('clear')
    }
  },
  components: {
   AdsButton
  }
};
</script>
<style lang="scss" scoped>
@import '../../styles/variables.scss';
.filter-options {
  min-width: 200px;
}
.v-chip {
  &.disabled {
    font-weight: bold;
  }
  .theme--light & {
    background-color: $ads-light-blue;
    border: 1px solid $ads-navy;
    color: $ads-navy;
  }
  // overriding the selected styles for dark theme
  &.selected {
    .theme--dark & {
      background-color: $ads-dark;
      border: 1px solid $ads-navy-dark;
      color: $ads-navy-dark;
    }
  }
}

::v-deep .v-input .v-input__slot {
  margin-bottom: 0;
}
// menu close button focus styles
.v-menu {
  &__content {
    .v-btn {
      .theme--dark & {
        color: white;
        &:focus {
          border: 2px solid $ads-white;
          &:before {
            opacity: 0;
          }
        }
      }
      &:focus {
        border: 2px solid $ads-dark-60;
        &:before {
          opacity: 0;
        }
      }
    }
    .v-list {
      padding: 10px;
    }
  }
}

</style>
